import type { ReactNode } from 'react';
import { AlertTriangle, RefreshCw } from 'lucide-react';
import { cn } from '../utils/cn.js';
import { Button } from './Button.js';

export interface ErrorBannerProps {
  title?: string;
  message: ReactNode;
  onRetry?: () => void;
  className?: string;
}

export function ErrorBanner({
  title = 'Something went wrong',
  message,
  onRetry,
  className,
}: ErrorBannerProps) {
  return (
    <div role="alert" className={cn('error-banner', className)}>
      <div className="error-icon" aria-hidden>
        <AlertTriangle size={18} />
      </div>
      <div className="error-body">
        <div className="error-title">{title}</div>
        <div className="error-msg">{message}</div>
      </div>
      {onRetry ? (
        <Button size="sm" variant="secondary" onClick={onRetry}>
          <RefreshCw size={14} aria-hidden />
          <span>Retry</span>
        </Button>
      ) : null}
    </div>
  );
}
